import React, { useState } from "react";
import CommonLayout from "../CommonLayout";
import Change_Password_Header from "../../../Assets/change_password_header.png";
import { Button, Form, message, Typography } from "antd";
import { useForm } from "antd/es/form/Form";
import PinInput from "../../Common/Components/PinInput";
import { useTranslation } from "react-i18next";
import { updatePin } from "../../../Services/UserProfileServices";
import "./index.css";
import {
  setAccessToken,
  setPhoneNumber,
  setVuaId,
} from "../../../Services/LocalStorageServices";
import { Routes } from "../../../Utils/Constants/routes";
import { useHistory } from "react-router-dom";
import { translation } from "../../../i18n/translationConstant";

const ChangePassword: React.FC = () => {
  const [updatedPin, setUpdatePin] = useState({
    oldPin: "",
    newPin: "",
    confirmNewPin: "",
  });
  const [form] = useForm();
  const { t } = useTranslation();

  const checkConfirmPassword = (_: any, value: string) => {
    if (value && value !== updatedPin.newPin && value.length === 6)
      return Promise.reject(new Error(t("lblPinMatchError")));
    return Promise.resolve();
  };

  const checkNewPassword = (_: any, value: string) => {
    if (value && value === updatedPin.oldPin)
      return Promise.reject(new Error(t("lblResetPinError")));
    return Promise.resolve();
  };
  const { replace } = useHistory();
  const formSubmit = (values: any) => {
    updatePin(values.oldPin, values.newPin).then(() => {
      form.resetFields();
      message.success(t("lblPinUpdateSuccess"));
      setAccessToken("");
      setPhoneNumber("");
      setVuaId("");
      replace(Routes.login);
    });
  };
  return (
    <CommonLayout imageUrl={Change_Password_Header} title={t(translation.lblResetPin)}>
      <div className="width25 justifyCenter">
        <Form
          form={form}
          name="basic"
          onFinish={formSubmit}
          autoComplete="off"
          className="width100 justifyCenter"
        >

          {/* Removed the old pin section*/}
          {/* <div className="marginTop30">
            <Typography.Text>{t("lblOldPin")}</Typography.Text>

            <PinInput
              className="inputCss2 changePasscodePin"
              label={t("lblEnterPin")}
              nameField="oldPin"
              // tslint:disable-next-line: jsx-no-lambda
              onChange={(pin) =>
                setUpdatePin((old) => ({ ...old, oldPin: pin }))
              }
            />
          </div> */}

          <div className="marginTop10">
            <Typography.Text>{t("lblNewPin")}</Typography.Text>

            <PinInput
              className="inputCss2 changePasscodePin"
              label={t("lblEnterPin")}
              nameField="newPin"
              customRule={checkNewPassword}
              // tslint:disable-next-line: jsx-no-lambda
              onChange={(pin) =>
                setUpdatePin((old) => ({ ...old, newPin: pin }))
              }
            />
          </div>
          <div className="marginTop10">
            <Typography.Text>{t("lblConfirmPin")}</Typography.Text>

            <PinInput
              className="inputCss2 changePasscodePin"
              label={t("lblEnterPin")}
              nameField="confirmNewPin"
              customRule={checkConfirmPassword}
              // tslint:disable-next-line: jsx-no-lambda
              onChange={(pin) =>
                setUpdatePin((old) => ({ ...old, confirmNewPin: pin }))
              }
            />
          </div>

          <div className="row justifyCenter marginTop20 width100 ">
            <Button htmlType="submit" className="profileSubmitButton">
              {t("lblResetPin")}
            </Button>
          </div>
        </Form>
      </div>
    </CommonLayout>
  );
};

export default ChangePassword;
